import React from 'react';
import { Container } from 'react-bootstrap';

const Map = () => {
  return (
    <Container fluid className="p-3">
      <iframe
      src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3922.7493790036374!2d76.2143301!3d10.520395200000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba7ef44dd6a9ce9%3A0x156bab078b2fca07!2sHOLY%20INSTITUTION!5e0!3m2!1sen!2sin!4v1725044889286!5m2!1sen!2sin'
        style={{ width: '100%', border: 0 }} // Responsive style
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Holy Institution Location"
      ></iframe>
    </Container>
  );
};

export default Map;
